import { NAME } from './constants';

export const FETCH_VERSION = `${NAME}/FETCH_VERSION`;
export const FETCH_VERSION_FAILURE = `${NAME}/FETCH_VERSION_FAILURE`;
export const FETCH_VERSION_SUCCESS = `${NAME}/FETCH_VERSION_SUCCESS`;

export const SET_NEW_VERSION_AVAILABLE = `${NAME}/SET_NEW_VERSION_AVAILABLE`;
